import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import { Card, Col, Row } from "react-bootstrap";
import { Trash } from "react-bootstrap-icons";
import FormRepeater from "../../../../../../../common/FormReapeater.jsx"
import ButtonWithIcon from "../../../../../../../common/ButtonWithIcon.jsx";
import InputWiz from "../../../../../../../common/inputs/wizard/InputWiz.jsx";
import { HeaderTitle } from "../../../../../../../common/HeaderTitle.jsx";
import { ModalWyszukajZrodloFinansowania } from "../../../modals.jsx";
import { Icons } from "../../../../../../../common/Icons.jsx";
import InputNumericWiz from "../../../../../../../common/inputs/wizard/InputNumericWiz.jsx";


const SourceRow = ({ row, setRow, idx, remove, parent, wiz, selectedRef }) => {
    const [showSearchModal, setShowSearchModal] = useState(false);

    const handleChooseFromModal = (chosen) => {
        if (!chosen) return;

        selectedRef.current[idx] = {
            nazwa_zrodla: chosen.nazwa ?? '',
            typ_zrodla: chosen.typ ?? ''
        };

        const currentList = Array.isArray(wiz?.form?.[parent]) ? [...wiz.form[parent]] : [];

        while (currentList.length <= idx) {
            currentList.push({ nazwa_zrodla: '', typ_zrodla: '', kwota: '' });
        }

        currentList[idx] = {
            ...(currentList[idx] || {}),
            nazwa_zrodla: chosen.nazwa ?? '',
            typ_zrodla: chosen.typ ?? ''
        };

        wiz.setValue(parent, currentList);
        setShowSearchModal(false);
    };

    const handleKwotaChange = (key, value) => {
        const currentList = Array.isArray(wiz?.form?.[parent]) ? [...wiz.form[parent]] : [];
        while (currentList.length <= idx) {
            currentList.push({ nazwa_zrodla: '', typ_zrodla: '', kwota: '' });
        }
        currentList[idx] = {
            ...(currentList[idx] || {}),
            [key]: value
        };
        wiz.setValue(parent, currentList);
    };

    const currentNazwa = wiz?.form?.[parent]?.[idx]?.nazwa_zrodla ?? '';
    const currentKwota = wiz?.form?.[parent]?.[idx]?.kwota ?? '';

    return (
        <>
            <Card className={'d-flex flex-column gap-2 mb-3 w-100'} key={idx}>
                <Card.Header className={'d-flex justify-content-between align-items-center'}>
                    <HeaderTitle noHr size={'fs-6'} title={`Źródło ${idx + 1}`} />
                    <ButtonWithIcon
                        text={`Usuń źródło ${idx+1}`}
                        onClick={() => {
                            if (selectedRef.current) {
                                delete selectedRef.current[idx];
                                const newMap = {};
                                Object.keys(selectedRef.current).sort((a,b)=>a-b).forEach((k) => {
                                    const kn = parseInt(k, 10);
                                    newMap[kn < idx ? kn : kn - 1] = selectedRef.current[k];
                                });
                                selectedRef.current = newMap;
                            }
                            remove(idx);
                        }}
                        icon={<Trash/>}
                        variant={'danger'}
                        size={'md'}
                    />
                </Card.Header>

                <Card.Body className={'p-3'}>
                    <Row className="align-items-end mb-3">
                        <Col xs={12} md={7}>
                            <InputWiz
                                wiz={wiz}
                                keyName={`${parent}.${idx}.nazwa_zrodla`}
                                row={row}
                                setRow={setRow}
                                idx={idx}
                                label={`F.${idx +1}.1 Nazwa źródła`}
                                readOnly
                                disabled={true}
                                value={currentNazwa}
                                title={currentNazwa}
                            />
                        </Col>

                        <Col xs={12} md={3}>
                            <InputNumericWiz
                                wiz={wiz}
                                keyName={`${parent}.${idx}.kwota`}
                                row={row}
                                setRow={handleKwotaChange}
                                idx={idx}
                                label={`F.${idx + 1}.2 Kwota [ZŁ]`}
                                value={currentKwota}
                                decimal={2}
                                max={99999999999999.99}
                                className="text-end"
                            />
                        </Col>

                        <Col xs={12} md={2} className={'mt-3 mt-md-0'}>
                            <ButtonWithIcon
                                icon={<Icons.search/>}
                                onClick={() => setShowSearchModal(true)}
                                variant={'primary'}
                                text={'Wyszukaj'}
                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <ModalWyszukajZrodloFinansowania
                show={showSearchModal}
                handleClose={() => setShowSearchModal(false)}
                onChoose={handleChooseFromModal}
            />
        </>
    );
};

SourceRow.propTypes = {
    row: PropTypes.object,
    setRow: PropTypes.func,
    idx: PropTypes.number,
    remove: PropTypes.func,
    parent: PropTypes.string,
    wiz: PropTypes.any,
    selectedRef: PropTypes.object
};


export const ZrodlaFinansowaniaRepeater = (props) => {
    const parent = props.parentListName || 'zrodla_list';

    const selectedRef = useRef({});

    useEffect(() => {
        const list = Array.isArray(props.wiz?.form?.[parent]) ? [...props.wiz.form[parent]] : [];

        let changed = false;
        // scal wartości z selectedRef do listy, ale tylko tam gdzie brakuje lub różnią się
        for (let i = 0; i < Math.max(list.length, Object.keys(selectedRef.current).length); i++) {
            const sel = selectedRef.current[i];
            const item = list[i] || {};

            if (sel) {
                // jeśli item nie ma kluczy lub różni się od sel -> nadpisz częściowo
                const mustUpdate = (item.nazwa_zrodla !== sel.nazwa_zrodla) || (item.typ_zrodla !== sel.typ_zrodla);
                if (mustUpdate) {
                    list[i] = {
                        ...(item || {}),
                        nazwa_zrodla: sel.nazwa_zrodla,
                        typ_zrodla: sel.typ_zrodla
                    };
                    changed = true;
                }
            } else {

            }
        }

        if (changed) {
            props.wiz.setValue(parent, list);
        }
    }, [props.wiz?.form?.[parent]?.length]);

    const handleListChange = (newList) => {
        const currentList = props.wiz.form?.[parent] || [];
        
        if (newList.length > currentList.length) {
            const merged = [...currentList, ...newList.slice(currentList.length)];
            props.wiz.setValue(parent, merged);
        } else if (newList.length < currentList.length) {
            props.wiz.setValue(parent, newList);
        }
    };

    return (
        <FormRepeater
            value={props.wiz.form?.[parent] || []}
            onChange={handleListChange}
            addButtonText="Dodaj źródło"
            hideNativeDelete
            className={'w-100'}
            form={(row, setRow, idx, remove) => {
                return (
                    <SourceRow
                        row={row}
                        setRow={setRow}
                        idx={idx}
                        remove={remove}
                        parent={parent}
                        wiz={props.wiz}
                        selectedRef={selectedRef}
                    />
                );
            }}
        />
    );
};

ZrodlaFinansowaniaRepeater.propTypes = {
    wiz: PropTypes.any.isRequired,
    parentListName: PropTypes.string
};

export default ZrodlaFinansowaniaRepeater;
